// Resize remote Unsplash images on their CDN instead of downloading the
// 1600px originals: auto=format serves WebP/AVIF where the browser supports it.
export const sized = (url, w) =>
  url && url.includes("images.unsplash.com")
    ? url.replace(/([?&])w=\d+/, `$1w=${w}`).replace(/([?&])q=\d+/, "$1q=70").replace(/fm=jpg&?/, "") + "&auto=format"
    : url;

export const srcSet = (url, widths = [480, 800, 1200]) =>
  url && url.includes("images.unsplash.com") ? widths.map((w) => `${sized(url, w)} ${w}w`).join(", ") : undefined;
